import { createContext } from "@singlestore/fusion/react-utils/context";

type NavigationContextType = {
    navigationPanePosition: number;
    setNavigationPanePosition: (top: number) => void;
};

export const [NavigationProvider, useNavigationPane] =
    createContext<NavigationContextType>();
